import { render, staticRenderFns } from "./chateau-dyquem-bordeaux.vue?vue&type=template&id=578a649f&scoped=true"
import script from "./chateau-dyquem-bordeaux.vue?vue&type=script&lang=js"
export * from "./chateau-dyquem-bordeaux.vue?vue&type=script&lang=js"
import style0 from "./chateau-dyquem-bordeaux.vue?vue&type=style&index=0&id=578a649f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578a649f",
  null
  
)

export default component.exports